module.exports = __webpack_public_path__ + "static/media/collaboration.f5c44965.svg";